import { monaFont } from '@/styles/fonts';
import { ELButton } from '@davincihealthcare/elty-design-system-react';
import { ArrowRightIcon, LockClosedIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import ModalFindBestClinic from './ModalFindBestClinic';
import FakeClinicHeader from './FakeClinicHeader';
import { useState } from 'react';

type CardFindBestClinicProps = {
  service?: string;
};

const CardFindBestClinic: React.FC<CardFindBestClinicProps> = ({ service }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="overflow-x-hidden rounded-lg shadow-cardListing">
        <div className="bg-brandBlue-700 px-3 pb-2 pt-3 text-center text-sm font-semibold uppercase tracking-widest text-white">
          ⭐️ CONSIGLIATO ⭐️
        </div>

        <div className="flex flex-col items-center gap-5 bg-neutral-surface px-3 py-4 [&>button]:w-full [&>button]:px-10 [&>button]:md:w-auto">
          <div className="text-center">
            <div className={clsx(monaFont.className, 'text-2xl font-[750] text-primary font-stretch-[80%]')}>
              Trova la clinica migliore per te
            </div>
            <div className="text-sm font-semibold text-neutral-lighter">3 domande veloci, risultato su misura</div>
          </div>

          <div className="relative w-full overflow-hidden rounded-lg border border-dashed border-neutral-inactive px-3 py-2">
            <FakeClinicHeader />

            <button
              type="button"
              className="absolute inset-0 z-10 flex cursor-pointer flex-col items-center justify-center gap-1"
              onClick={() => setIsModalOpen(true)}
            >
              <div className="flex size-12 items-center justify-center rounded-full bg-brandBlue-200">
                <LockClosedIcon className="size-6 text-primary-active" />
              </div>
              <span className="text-xs font-semibold text-neutral-lighter">La clinica per le tue esigenze</span>
            </button>
          </div>

          <ELButton
            label="Scopri la clinica migliore per te"
            color="primary"
            size="small"
            variant="floating"
            trailingIcon={<ArrowRightIcon />}
            onClick={() => setIsModalOpen(true)}
          />
        </div>
      </div>

      <ModalFindBestClinic isOpen={isModalOpen} setIsOpen={setIsModalOpen} service={service} />
    </>
  );
};

export default CardFindBestClinic;
